module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADrSURBVEhL7dKxisJAEMbxeFjZHIiFpeAT+DS+yIGlhegr2NlY2nviIVxhYSWCrViJjSgoamHj/QcysISNQ1QE9T74EXazO8NuErxszqG4WO/NPLyBNU4cq6A1NmMVsMaJYxWMjhPHKvDf4EmygB5V7fGNEm5OB9EG6gC3SRE9bBFdO4M3ZbgLN5hggDm60AzhrnXV4U0GO/g2/aAFjRRpYwq5Rl0nJ8oiNjW4hV1jyNXIN/G9F1+4GDnFCL7N4hQ+j86ckm+YgplPNLHEGn00oIV+kUMFK8jfV0UaVycPbVCQiXvnA9rgrRIEfy9vi2K8bbX1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-irrigation/dark/24.png
// module id = 2206
// module chunks = 2